export default __webpack_public_path__ + "static/media/logo.e330ef0f.png";